import { Button, Modal, ModalBody, ModalContent } from "@heroui/react";
import { BadgeCheckIcon } from "lucide-react";
import type { BridgeTxClaimedSuccess } from "../../state/types";
import { formatTimestamp } from "../../utils";
import { TxHashLink } from "../TxHashLink";
import { ClaimInfoCard } from "./ClaimInfoCard";
import { TransactionTypeChip } from "./TransactionTypeChip";

export function ClaimSuccessModal({
  isOpen,
  onClose,
  claimedTxData,
}: {
  isOpen: boolean;
  onClose: () => void;
  claimedTxData: BridgeTxClaimedSuccess | null;
}) {
  if (!claimedTxData) {
    return null;
  }

  const isDeposit = claimedTxData.bridgeType === "deposit";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideCloseButton
      size="lg"
      isDismissable={false}
      isKeyboardDismissDisabled={true}
      classNames={{
        base: "turnstile-modal-border rounded-3xl",
        closeButton: "text-white text-xl top-4 right-5",
        header: "pt-5 pb-3",
        body: "items-center p-6 pt-0 gap-4",
        backdrop: "turnstile-modal-backdrop",
      }}
    >
      <ModalContent>
        <ModalBody className="flex items-center gap-4 p-8">
          <BadgeCheckIcon className="size-24 stroke-1 text-green-500/90 fill-green-500/10 " />

          <p className="font-semibold text-large">Claim completed!</p>

          <ClaimInfoCard
            amount={claimedTxData.amount}
            tokenDecimals={claimedTxData.tokenDecimals}
            tokenSymbol={claimedTxData.tokenSymbol}
          />

          <div className="flex flex-col gap-2 w-full">
            <div className="flex items-center justify-between w-full">
              <div className="text-[#ADC0D0]">Date & time</div>
              <div className="font-semibold">{formatTimestamp(claimedTxData.claimTimestamp)}</div>
            </div>

            <div className="flex items-center justify-between w-full">
              <div className="text-[#ADC0D0]">Transaction Hash</div>
              <div className="font-semibold">
                <TxHashLink
                  txHash={claimedTxData.claimTxHash}
                  source={claimedTxData.bridgeType === "deposit" ? "l2" : "l1"}
                />
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="text-[#ADC0D0]">Transaction type</div>
              <TransactionTypeChip type={isDeposit ? "private" : "public"} />
            </div>
          </div>

          {isDeposit ? (
            <>
              <p className="text-small text-[#AEC4D3]">
                If you want to hide your balance on the Aztec Network, use Shielding feature to make them private.{" "}
              </p>

              <div className="flex gap-2 w-full">
                <Button fullWidth variant="bordered" color="primary" size="lg" radius="full">
                  Shield tokens
                </Button>
                <Button fullWidth color="primary" size="lg" radius="full" onPress={onClose}>
                  Close
                </Button>
              </div>
            </>
          ) : (
            <div className="w-full">
              <Button fullWidth color="primary" size="lg" radius="full" onPress={onClose}>
                Close
              </Button>
            </div>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
